import React from 'react';

const CriticalError: React.FC = () => {
  return (
    <p style={{margin: 'auto', textAlign: 'center', fontSize: '24px'}}>К сожалению, на сайте ведутся технические работы. Скоро доступ восстановится.</p>
  );
};

export default CriticalError;